
function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

const routes_base = [
  {path: 'group/member', component: loadPage('MemberList', 'group/member')},
  {path: 'group/album', component: loadPage('AlbumList', 'group/album')},
  {path: 'group/album/create', component: loadPage('AlbumCreate', 'group/album')},
  {path: 'group/album/post', component: loadPage('AlbumPostList', 'group/album')},
  {path: 'group/album/post/create', component: loadPage('AlbumPostCreate', 'group/album')},
  {path: 'group/duty', component: loadPage('DutyList', 'group/duty')},
  {path: 'group/duty/create', component: loadPage('DutyCreate', 'group/duty')},
  {path: 'group/calendar', component: loadPage('CalendarList', 'group/calendar')},
  {path: 'group/calendar/create', component: loadPage('CalendarCreate', 'group/calendar')},
  {path: 'group/notice', component: loadPage('NoticeList', 'group/notice')},
  {path: 'group/notice/create', component: loadPage('NoticeCreate', 'group/notice')},
  {path: 'group/board/base/create', component: loadPage('BoardBaseCreate', 'group/board')},
  {path: 'group/board/base', component: loadPage('BoardBaseList', 'group/board')},
  {path: 'group/board/base/post', component: loadPage('BoardPostBaseList', 'group/board')},
  {path: 'group/board/base/post/create', component: loadPage('BoardPostBaseCreate', 'group/board')},
  {path: 'group/board', component: loadPage('BoardList', 'group/board')},
  {path: 'group/board/create', component: loadPage('BoardCreate', 'group/board')},
  {path: 'group/board/post', component: loadPage('BoardPostList', 'group/board')},
  {path: 'group/board/post/create', component: loadPage('BoardPostCreate', 'group/board')},
];

const routes_admin = [
  {path: 'group/list', component: loadPage('GroupList', 'group')}
];


const routes = {
  'base': routes_base,
  'admin': routes_admin.concat(routes_base)
};

export default routes;

